import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { getResponseErrors, getResponseStatus, translateApiError } from '@app/services/apiErrors';

export const useApiErrorMessage = (): ((err: unknown) => string) => {
  const validationT = useTranslation(NSKeys.validation);
  const commonT = useTranslation(NSKeys.common);

  return useCallback(
    (err: unknown) => {
      const [error] = getResponseErrors(err);
      if (error) {
        return translateApiError(error, validationT.t) || commonT.t('error400');
      }
      switch (getResponseStatus(err)) {
        case 403:
          return commonT.t('noAccess');
        case 404:
          return commonT.t('notFound');
        default:
          return commonT.t('error400');
      }
    },
    [validationT.t, commonT.t]
  );
};
